import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../shared/utils/api.js'

export const fetchAgents = createAsyncThunk('agents/fetch', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/agents/agent/users`)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const fetchSingleAgent = createAsyncThunk('agent/fetch', async (agentId, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/agents/agent/users/${agentId}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const approveAgent = createAsyncThunk('agent/approve', async (agentId, { rejectWithValue }) => {
  try {
    const response = await api.patch(`/v1/agents/validate/${agentId}`, {})
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

export const disapproveAgent = createAsyncThunk('agent/disapprove', async (agentId, { rejectWithValue }) => {
  try {
    const response = await api.patch(`/v1/agents/disapprove/${agentId}`, {})
    return response.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

export const deactivateAgentAccount = createAsyncThunk(
  'agent/deactivate',
  async ({ userId, message }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/v1/admin/deactivate/account/user/${userId}`, {
        message
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const createAgent = createAsyncThunk('agent/create', async agentData => {
  const response = await api.post('/v1/agents/agent/users', agentData)
  return response.data
})

export const updateAgent = createAsyncThunk('agent/update', async ({ agentId, data }, { rejectWithValue }) => {
  try {
    const response = await api.patch(`/v1/agents/agent/users/${agentId}`, data)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const deleteAgent = createAsyncThunk('agent/delete', async agentId => {
  const response = await api.delete(`/v1/agents/agent/users/delete/${agentId}`)
  return response.data
})

export const fetchAgentTeams = createAsyncThunk('agent/fetchTeams', async (agentId, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/admin/agent/${agentId}/teams`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

export const fetchAgentTeamMembers = createAsyncThunk(
  'agent/fetchTeamMembers',
  async (agentId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/v1/admin/agent/${agentId}/team-members`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

export const fetchAgentContacts = createAsyncThunk('agent/fetchContacts', async (agentId, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/admin/agent/${agentId}/contacts`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})

export const fetchAgentReviews = createAsyncThunk('agent/fetchReviews', async (agentId, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/reviews/agent/${agentId}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || error.message)
  }
})